import { DIGITAL_CONFIRM, DIGITAL_CONFIRM_SUCCESS, DIGITAL_CONFIRM_ERROR, DIGITAL_CONFIRM_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DigitalConfirm = (state = initialState, action) => {
  switch (action.type) {
    case DIGITAL_CONFIRM:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DIGITAL_CONFIRM_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DIGITAL_CONFIRM_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DIGITAL_CONFIRM_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DigitalConfirm;
